import React from 'react';

export default function Sparkline({ data = [], width = 88, height = 28, stroke = '#14B7DD', strokeWidth = 2, fill = false }) {
  if (!data || data.length === 0) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((d, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((d - min) / range) * height;
    return `${x},${y}`;
  }).join(' ');

  const last = data[data.length - 1];
  const first = data[0];
  const positive = last >= first;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{ display: 'block' }}>
      {fill && (
        <polyline points={pts} fill={positive ? 'rgba(20,183,221,0.08)' : 'rgba(220,38,38,0.06)'} stroke="none" />
      )}
      <polyline points={pts} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
